import { createFileRoute } from '@tanstack/react-router'

import CreatePenyuluhProvinsiPage from '@/components/pages/backoffice/_klb-penyuluh/_provinsi/_create/containers/CreatePenyuluhProvinsiPage'

export const Route = createFileRoute(
  '/_backoffice/klb-penyuluh/provinsi/create/'
)({
  component: CreatePenyuluhProvinsiPage
})
